import React from "react";
import { InputNumber, Form } from "antd";

const FormInputNumberComponent = ({
    name,
    rules,
    autoComplete,
    onKeyPress,
    className,
    placeholder,
    disabled,
    addonAfter,
    addonBefore,
    min,
    max,
    step,
    precision,
    changeOnWheel,
    controls,
    prefix,
    suffix,
    help = "",
}) => {
    return (
        <Form.Item name={name} rules={rules} className={className} help={help}>
            <InputNumber
                onKeyPress={onKeyPress}
                autoComplete={autoComplete}
                placeholder={placeholder}
                disabled={disabled}
                addonAfter={addonAfter}
                addonBefore={addonBefore}
                min={min}
                max={max}
                step={step}
                precision={precision}
                changeOnWheel={changeOnWheel}
                controls={controls}
                prefix={prefix}
                suffix={suffix}
            />
        </Form.Item>
    );
};

export default FormInputNumberComponent;
